import { IPermissionData } from "Global/Base/DataSources/Interfaces";
import { ObjectUtils } from "Global/Base/Utils/ObjectUtils";

/**
 * Práva pro atributů pro jeden záznam
 * @internal
 */
export class RowPermissions {
    private _rowPermData: Map<string, IPermissionData> = new Map<string, IPermissionData>();

    /** Vrací právo pro zadaný atribut */
    public get(attrName: string): IPermissionData | undefined {
        attrName = ObjectUtils.removeTypeCasting(attrName);
        //Napřed se zkusí získat přesná shoda
        if (this._rowPermData.has(attrName))
            return this._rowPermData.get(attrName);
        //attrName může obsahovat název vazby s "." atribut (např. Banka.kod). V takovém případě je v kolekci _rowPermData uloženo právo jen pro vazbu (Banka) #25392
        attrName = ObjectUtils.removeTypeCasting(attrName).split(".")[0]; //vezme první název atributu před první ".";
        //TODO: bug když attrname obsahuje dvě a více vazeb (Např. X.Y.Z), ale restrikce existují pro druhý objekt ve vazbě (Y), nejsou brány v úvahu - server je vůbec neposlal. Musí se jednat o kompozitní vazby, jinak to nemá smysl. Nemáme takový TC, Lukáš Tůma to zkusí prověřit.
        return this._rowPermData.get(attrName);
    }

    /**Uloží právo pro zadaný atribut */
    public set(attrName: string, perm: IPermissionData): void {
        this._rowPermData.set(attrName, perm);
    }
}
